// src/components/PaneHeading.jsx
//
// PANE-HEADING-AUDIT: Single shared implementation of the 3px blue accent-bar
// + 14 / 700 / T.dark pane-heading pattern.
//
// Every top-level pane/section heading in the app must use this component.
// Nested-card headings (13px tier, inside a card within a pane) are exempt.
//
// Props
//   children — heading label (string or JSX)
//   sub      — optional secondary label rendered after a "·" separator,
//              in 11 / 600 / T.light / uppercase
//   style    — optional style overrides applied to the wrapper div
//              (use to zero out the default marginBottom when the caller's
//              own wrapper already owns the spacing)

import React from "react";
import { T } from "../app/tokens.js";

export function PaneHeading({ children, sub, style, barProps, labelStyle, ...props }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: T.fsMd,
        fontWeight: T.fwBold,
        color: T.dark,
        marginBottom: 12,
        ...style,
      }}
      {...props}
    >
      <span
        style={{
          display: "inline-block",
          width: 3,
          height: 14,
          background: T.blue,
          borderRadius: 2,
          flexShrink: 0,
        }}
        {...barProps}
      />
      <span style={labelStyle}>{children}</span>
      {sub && (
        <span
          style={{
            fontWeight: T.fwSemibold,
            color: T.light,
            fontSize: T.fsXs,
            textTransform: "uppercase",
            letterSpacing: 0.3,
          }}
        >
          · {sub}
        </span>
      )}
    </div>
  );
}
